<div class="mt-2">
    <table class="min-w-500 overflow-y-visible mat-elevation-z">
        <thead>
            <tr>
                <th>#</th>
                <th>Desde</th>
                <th>Hasta</th>
                <th>Precio</th>
                <th>
                    <button *ngIf="!openFormAdd" mat-icon-button color="primary" (click)="openFormAdd = true" 
                        matTooltip="Nuevo Registro">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                        <span></span>
                    </button>
                    <button *ngIf="openFormAdd" mat-icon-button color="primary" (click)="openFormAdd = false;resetFormAddListScale()"
                        matTooltip="Cerrar">
                        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="openFormAdd == true" style=" background: rgba(197, 191, 191, 0.2); border-radius: 12px;">
                <td></td>
                <td>
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="currentCreateScale.quantityFrom" name="quantityFrom">
                    </mat-form-field>
                </td>
                <td>   
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="currentCreateScale.quantityTo" name="quantityTo">
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="currentCreateScale.price" name="price">
                    </mat-form-field>
                </td>
                <td></td>
                <td>
                    <div class="col-span-2" style="text-align:center">
                        <button color="primary" mat-icon-button (click)="onAddToListScale()">
                            <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
            @if(listScalesAdd.length > 0){
            <tr *ngFor="let item of listScalesAdd; let i = index">
                <td valign="center">{{(i+1)}}</td>
                <td>
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="item.quantityFrom" [disabled]="!item.isEditMode">
                    </mat-form-field>
                </td>
                <td>       
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="item.quantityTo" [disabled]="!item.isEditMode">
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field appearance="fill" class="mt-2 w-full" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="item.price" [disabled]="!item.isEditMode">
                    </mat-form-field>
                </td>
                <td>
                    <div class="col-span-2" style="text-align:center">
                        <button color="primary" mat-icon-button (click)="onUpdateScale(item, i)" *ngIf="!item.isEditMode">
                            <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                        </button>
                        <button color="primary" mat-icon-button (click)="onSaveScale(item, i)" *ngIf="item.isEditMode">
                            <mat-icon svgIcon="heroicons_outline:document"></mat-icon>
                        </button>
                        <button color="warn" mat-icon-button (click)="onDeleteScale(item, i)">
                            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>